import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { SaaSServices } from '../services/saasServices';
import { unwrapApiData } from '../auth/saasSession';
import { formatInstitutionDateTime } from '../uitilites/institutionTime';

export const activeBreakGlassNotices = (notices, now = Date.now()) => (
  (Array.isArray(notices) ? notices : []).filter((notice) => {
    if (
      notice?.category !== 'break_glass_support_access'
      || notice?.revoked_at
      || notice?.active === false
      || ['pending', 'activation_failed'].includes(notice?.status)
    ) return false;
    const expiresAt = new Date(notice?.detail?.expires_at || 0).getTime();
    return Number.isFinite(expiresAt) && expiresAt > now;
  })
);

export default function InstitutionSecurityBanner({ enabled }) {
  const [notices, setNotices] = React.useState([]);

  React.useEffect(() => {
    if (!enabled) {
      setNotices([]);
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      const response = await SaaSServices.listSecurityNotices();
      if (!cancelled) setNotices(activeBreakGlassNotices(unwrapApiData(response)));
    };
    load();
    const timer = window.setInterval(load, 15_000);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, [enabled]);

  const active = activeBreakGlassNotices(notices);
  if (!enabled || !active.length) return null;
  const notice = active[0];
  return (
    <div className="flex min-h-12 items-center justify-between gap-4 bg-red-700 px-4 py-2 text-sm font-semibold text-white" role="alert" data-testid="institution-break-glass-banner">
      <span className="flex items-center gap-2">
        <ShieldAlert className="h-5 w-5 shrink-0" />
        Emergency Platform Support access is active · Ticket {notice.detail?.ticket_number || '—'} · Ends {formatInstitutionDateTime(notice.detail?.expires_at, notice.detail?.institution_timezone)}
      </span>
      <a href="/access-administration" className="shrink-0 rounded bg-white/15 px-3 py-1 hover:bg-white/25">Review or revoke</a>
    </div>
  );
}
